/* global findDuplicateRoute, overridePhoneValidationButtonDisable, overrideEmailValidationButtonDisable, loginStep2Route */
import { ajax } from '@common/ajax-helpers';
import { errorHandler } from '@common/errors';
import { failure } from '@common/alert';

/**
 * Query DB for existing lead based on params.
 * @param {object} params
 * @param {string} field
 * @return {Promise}
 */
function queryDuplicateLeads(params, field) {
    return ajax({
        method: 'POST',
        url: findDuplicateRoute,
        data: {
            ...params,
            field,
        },
    });
}

/**
 * Sets variable if lead says "Oops, I'm not ...".
 * @param {boolean|null} value
 * @param {string} first
 * @param {string} last
 * @param {string} phone
 */
function leadIsNotMatch(first, last, phone, value = null) {
    const string = `${first.toLowerCase()}_${last.toLowerCase()}_${phone}`;

    if (value == null) {
        const current = window?.t5DuplicateCheck || null;
        return string === current;
    } else {
        window.t5DuplicateCheck = string;
    }
}

/**
 * Reset disabled fields/buttons on apply form.
 */
function resetDisabled() {
    let $disabledNextButton = $('.form-wizard-buttons > button.btn-next[disabled]');
    if ($disabledNextButton.length) {
        $disabledNextButton.prop('disabled', false);
    } else {
        $('.btn-next:disabled').prop('disabled', false);
    }
}

function saveApplicationCurrentState() {
    const currentState = {};
    const $fields = $(':input:visible');

    $fields.each((index, element) => {
        let name = $(element).attr('name');
        if (name !== undefined) {
            currentState[name] = $(element).val();
        }
    });
    $fields.prop('readonly', true);

    sessionStorage.setItem('funnel__dupe_check_state', JSON.stringify(currentState));
}

function redirectToLogin(duplicatedEmail = null, duplicatedPhone = null) {
    const currentParams = new URLSearchParams(window.location.search);
    const loginUrl = new URL(loginStep2Route, window.location.origin);

    const paramsToSet = {
        email: duplicatedEmail,
        phone: duplicatedPhone,
        source: currentParams.get('source'),
        job: currentParams.get('job'),
        referer: currentParams.get('referer'),
    };

    Object.entries(paramsToSet).forEach(([key, value]) => {
        if (value) loginUrl.searchParams.set(key, value);
    });

    $(window).off('beforeunload');
    window.location = loginUrl.toString();
}

function handleDuplicatePhone($first, $last, $phone, phoneFormatted) {
    // save current state
    saveApplicationCurrentState();
    // redirect to login step 2 with the duplicated phone and destination params
    redirectToLogin(null, phoneFormatted);
}

function handleDuplicateEmail($email) {
    // save current state
    saveApplicationCurrentState();
    // redirect to login step 2 with the duplicated phone and destination params
    redirectToLogin($email.val(), null);
}

/**
 * Check for duplicate leads based on phone, first, last name.
 *
 * @param {jQuery} $phone
 * @param {jQuery} $first
 * @param {jQuery} $last
 */
export function checkDuplicatePhone($phone, $first, $last) {
    if (sessionStorage.getItem('funnel__dupe_check_state_filling')) {
        return;
    }

    const phoneFormatted = $phone.val().toString().replace(/\D/g, '');

    const $nextBtn = $('.btn-next');

    if (!$phone.is(':visible')) {
        return;
    }

    if (!phoneFormatted.length || !$first.val() || !$last.val()) {
        if ($nextBtn.is(':visible') && !$nextBtn.is(':disabled') && !overridePhoneValidationButtonDisable) {
            $nextBtn.prop('disabled', true);
        }
        return;
    }

    $phone.data('verifying', true);
    $first.data('verifying', true);
    $last.data('verifying', true);

    if (!overridePhoneValidationButtonDisable) {
        $nextBtn.prop('disabled', true);
    }

    if (!leadIsNotMatch($first.val(), $last.val(), phoneFormatted)) {
        $phone.siblings('ul.custom_async_validation').remove();
        queryDuplicateLeads({ phone: phoneFormatted, first: $first.val(), last: $last.val() }, 'sms')
            .then((data) => {
                if (data.exists) {
                    if (data.mismatch) {
                        failure(
                            'Something went wrong.<br><a href="javascript:;" id="btn_duplicate_leads_help" class="text-black3">Click here for assistance</a>.',
                            'Error!',
                            {showConfirmButton: false, showDenyButton: false, showCancelButton: false, allowOutsideClick: false, allowEscapeKey: false},
                        );
                        return;
                    }

                    handleDuplicatePhone($first, $last, $phone, phoneFormatted);
                } else {
                    if (!overridePhoneValidationButtonDisable) {
                        resetDisabled();
                    }
                }
            })
            .catch((xhr) => {
                if (xhr.status === 422 && xhr?.responseJSON?.errors?.phone) {
                    let phoneErrors = xhr?.responseJSON?.errors?.phone;
                    let $errors = $(`<ul class="parsley-errors-list filled custom_async_validation" id="parsley-id-${$phone.attr('data-parsley-id')}" aria-hidden="false"></ul>`);

                    $errors.append($(`<li class="parsley-custom-error-message">${phoneErrors.shift()}</li>`));

                    $phone.addClass('parsley-error').after($errors);
                    return;
                }

                errorHandler(xhr);
            });
    } else {
        if (!overridePhoneValidationButtonDisable) {
            resetDisabled();
        }
    }
}

export function checkDuplicateEmail($email) {
    if (sessionStorage.getItem('funnel__dupe_check_state_filling')) {
        return;
    }

    const $nextBtn = $('.btn-next');

    if (!$email.is(':visible')) {
        return;
    }

    if (!$email.val()) {
        if ($nextBtn.is(':visible') && !$nextBtn.is(':disabled') && !overrideEmailValidationButtonDisable) {
            $nextBtn.prop('disabled', true);
        }
        return;
    }

    $email.data('verifying', true);

    if (!overrideEmailValidationButtonDisable) {
        $nextBtn.prop('disabled', true);
    }
    queryDuplicateLeads({ email: $email.val() }, 'email')
        .then((data) => {
            if (data.exists) {
                handleDuplicateEmail($email);
            } else {
                if (!overrideEmailValidationButtonDisable) {
                    resetDisabled();
                }
            }
        })
        .catch(errorHandler);
}

export function prefillCurrentState() {
    const savedState = sessionStorage.getItem('funnel__dupe_check_state');
    if (savedState !== null) {
        sessionStorage.setItem('funnel__dupe_check_state_filling', '1');

        let data = JSON.parse(savedState);
        for (let field of Object.keys(data)) {
            $(`[name="${field}"]`).val(data[field]).change();
        }

        sessionStorage.removeItem('funnel__dupe_check_state_filling');
    }
}
